import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { Ruoli } from 'src/app/models/ruoli';
@Injectable({
  providedIn: 'root',
})
export class RuoliService {
  private http = inject(HttpClient);
  url = environment.ildatoArticoliDpi + 'api/ruoli';

  list(): Observable<Ruoli[]>{
    return this.http.get<Ruoli[]>(this.url + "/list");
  }

}
